(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bootLive() {
    var root = document.querySelector('[data-urf-live]');
    var data = document.getElementById('urf-live-products');
    if (!root || !data || window.matchMedia('(max-width: 767px)').matches) return;
    var products = [];
    try { products = JSON.parse(data.textContent || '[]'); } catch (e) { products = []; }
    if (!products.length) return;

    var link = root.querySelector('[data-urf-live-link]');
    var img = root.querySelector('[data-urf-live-img]');
    var status = root.querySelector('[data-urf-live-status]');
    var title = root.querySelector('[data-urf-live-title]');
    var price = root.querySelector('[data-urf-live-price]');
    var cursor = 0;
    var paused = false;
    var hideTimer = 0;
    var cycleTimer = 0;

    function hideCard() {
      root.classList.remove('is-on');
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(function () {
        if (!root.classList.contains('is-on')) root.hidden = true;
      }, 380);
    }

    function show(item, label) {
      if (!item || paused) return;
      window.clearTimeout(hideTimer);
      link.href = item.url || link.getAttribute('href') || '/';
      img.src = item.image || '';
      img.alt = '';
      status.textContent = label || 'In the showroom';
      title.textContent = item.title || '';
      price.textContent = item.price || '';
      root.hidden = false;
      window.requestAnimationFrame(function () {
        root.classList.add('is-on');
      });
      hideTimer = window.setTimeout(hideCard, 3400);
    }

    function nextShowroom() {
      if (paused || !products.length) return;
      show(products[cursor % products.length], 'In the showroom');
      cursor += 1;
    }

    root.querySelector('[data-urf-live-close]').addEventListener('click', function () {
      paused = true;
      window.clearTimeout(hideTimer);
      window.clearInterval(cycleTimer);
      root.classList.remove('is-on');
      root.hidden = true;
    });

    document.addEventListener('urf:wishlist', function (event) {
      if (!event.detail.saved) return;
      var card = event.detail.card;
      show({
        title: card.getAttribute('data-title'),
        url: card.getAttribute('data-url'),
        price: card.getAttribute('data-price'),
        image: card.getAttribute('data-image')
      }, 'Saved to your wishlist');
    });

    if ('IntersectionObserver' in window) {
      var seen = {};
      var viewHold = false;
      var observer = new IntersectionObserver(function (entries) {
        if (viewHold) return;
        entries.some(function (entry) {
          if (!entry.isIntersecting) return false;
          var card = entry.target;
          var id = card.getAttribute('data-id');
          if (seen[id]) return false;
          seen[id] = true;
          viewHold = true;
          show({
            title: card.getAttribute('data-title'),
            url: card.getAttribute('data-url'),
            price: card.getAttribute('data-price'),
            image: card.getAttribute('data-image')
          }, 'You are viewing');
          window.setTimeout(function () { viewHold = false; }, 9000);
          return true;
        });
      }, { threshold: 0.7 });
      document.querySelectorAll('[data-urf-card]').forEach(function (card) {
        observer.observe(card);
      });
    }

    cycleTimer = window.setInterval(nextShowroom, 9000);
    window.setTimeout(nextShowroom, 1600);
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function bootHeader() {
    var header = document.querySelector('[data-urf-header]');
    if (!header) return;
    var shade = header.querySelector('[data-urf-shade]');
    var cartBody = header.querySelector('[data-urf-cart-body]');
    var routes = {
      add: header.getAttribute('data-cart-add'),
      change: header.getAttribute('data-cart-change'),
      cart: header.getAttribute('data-cart-url'),
      shop: header.getAttribute('data-shop-url')
    };
    var openName = '';
    var lastFocus = null;

    function setOpen(name) {
      if (name && !openName) lastFocus = document.activeElement;
      openName = name || '';
      header.querySelectorAll('[data-urf-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-urf-panel') !== openName;
      });
      header.querySelectorAll('[data-urf-open]').forEach(function (button) {
        button.setAttribute('aria-expanded', button.getAttribute('data-urf-open') === openName ? 'true' : 'false');
      });
      if (shade) shade.hidden = !openName || openName === 'search';
      document.documentElement.classList.toggle('urf-locked', !!openName && openName !== 'search');
      if (!openName) {
        if (lastFocus && lastFocus.focus) lastFocus.focus();
        return;
      }
      var panel = header.querySelector('[data-urf-panel="' + openName + '"]');
      var target = panel && panel.querySelector('input, [data-urf-close], a, button');
      if (target) target.focus();
    }

    function money(cents, currency) {
      try {
        return new Intl.NumberFormat('en-AU', { style: 'currency', currency: currency || 'AUD' }).format(cents / 100);
      } catch (e) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function renderCart(cart) {
      document.querySelectorAll('[data-urf-cart-count]').forEach(function (badge) {
        badge.textContent = cart.item_count;
        badge.hidden = cart.item_count === 0;
      });
      document.querySelectorAll('.CartCount').forEach(function (node) {
        node.textContent = cart.item_count;
      });
      var opener = header.querySelector('[data-urf-open="cart"]');
      if (opener) opener.setAttribute('aria-label', 'Cart, ' + cart.item_count + ' items');
      if (!cartBody) return;
      if (!cart.item_count) {
        cartBody.innerHTML = '<p class="urf-header__empty">Your cart is empty.</p>' +
          '<a class="urf-header__checkout" href="' + escapeHtml(routes.shop) + '">Shop the collection</a>';
        return;
      }
      var lines = cart.items.map(function (item) {
        var image = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        var variant = item.variant_title && item.variant_title !== 'Default Title'
          ? '<small>' + escapeHtml(item.variant_title) + '</small>' : '';
        return '<li>' +
          '<a href="' + escapeHtml(item.url) + '">' + (image ? '<img src="' + escapeHtml(image) + '" alt="" loading="lazy" width="76" height="76">' : '') + '</a>' +
          '<div>' +
            '<a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a>' + variant +
            '<p>' + money(item.final_line_price, cart.currency) + '</p>' +
            '<div class="urf-header__qty">' +
              '<button type="button" data-urf-cart-change data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Reduce quantity">−</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-urf-cart-change data-key="' + escapeHtml(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
              '<button type="button" class="urf-header__remove" data-urf-cart-change data-key="' + escapeHtml(item.key) + '" data-qty="0">Remove</button>' +
            '</div>' +
          '</div>' +
        '</li>';
      }).join('');
      cartBody.innerHTML = '<ul class="urf-header__lines">' + lines + '</ul>' +
        '<div class="urf-header__foot">' +
          '<p class="urf-header__total"><span>Subtotal</span><strong>' + money(cart.total_price, cart.currency) + '</strong></p>' +
          '<p class="urf-header__note">Delivery is calculated at checkout.</p>' +
          '<form action="' + escapeHtml(routes.cart) + '" method="post">' +
            '<button class="urf-header__checkout" type="submit" name="checkout">Checkout</button>' +
          '</form>' +
          '<a class="urf-header__view" href="' + escapeHtml(routes.cart) + '">View cart</a>' +
        '</div>';
    }

    function refreshCart() {
      return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) { return response.json(); })
        .then(function (cart) { renderCart(cart); return cart; });
    }

    function addToCart(form, button) {
      var label = button ? button.innerHTML : '';
      if (button) {
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
      }
      return fetch(routes.add, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'This item could not be added.');
          return data;
        });
      }).then(function () {
        return refreshCart();
      }).then(function () {
        setOpen('cart');
      }).catch(function (error) {
        window.alert(error.message);
      }).then(function () {
        if (button) {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          button.innerHTML = label;
        }
      });
    }

    header.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-urf-open]');
      if (opener) {
        event.preventDefault();
        var next = opener.getAttribute('data-urf-open');
        setOpen(openName === next ? '' : next);
        return;
      }
      if (event.target.closest('[data-urf-close]') || event.target === shade) {
        setOpen('');
        return;
      }
      var sub = event.target.closest('[data-urf-sub]');
      if (sub) {
        var opened = sub.parentElement.classList.toggle('is-open');
        sub.setAttribute('aria-expanded', opened ? 'true' : 'false');
        return;
      }
      var change = event.target.closest('[data-urf-cart-change]');
      if (change) {
        event.preventDefault();
        change.disabled = true;
        fetch(routes.change, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: change.getAttribute('data-key'), quantity: Number(change.getAttribute('data-qty')) })
        }).then(function (response) { return response.json(); })
          .then(renderCart)
          .catch(function () { window.location.href = routes.cart; });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && openName) setOpen('');
    });

    document.addEventListener('click', function (event) {
      if (openName === 'search' && !event.target.closest('.urf-header')) setOpen('');
    });

    document.addEventListener('click', function (event) {
      var button = event.target.closest('.product-form__cart-submit, .urf-pc__actions button[name="add"]');
      if (!button) return;
      var form = button.closest('form');
      if (!form || (form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (form.reportValidity && !form.reportValidity()) return;
      addToCart(form, button);
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      addToCart(form, form.querySelector('[type="submit"]'));
    }, true);
  }

  function bootWishlist() {
    var key = 'wishListsArr';
    function read() {
      try { return JSON.parse(window.localStorage.getItem(key) || '[]'); } catch (e) { return []; }
    }
    function write(list) {
      try { window.localStorage.setItem(key, JSON.stringify(list)); } catch (e) {}
    }
    function paint() {
      var list = read();
      document.querySelectorAll('[data-urf-wish-count]').forEach(function (badge) {
        badge.textContent = list.length;
        badge.hidden = list.length === 0;
      });
      document.querySelectorAll('.urf-pc__save').forEach(function (button) {
        var saved = list.indexOf(button.getAttribute('data-product-handle')) !== -1;
        button.classList.toggle('is-saved', saved);
        button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      });
    }
    document.addEventListener('click', function (event) {
      var button = event.target.closest('.urf-pc__save');
      if (!button) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      var handle = button.getAttribute('data-product-handle');
      var list = read();
      var index = list.indexOf(handle);
      if (index === -1) list.push(handle); else list.splice(index, 1);
      write(list);
      paint();
      document.dispatchEvent(new CustomEvent('urf:wishlist', {
        detail: { saved: index === -1, card: button.closest('[data-urf-card]') }
      }));
    }, true);
    paint();
  }

  function bootHero() {
    var root = document.querySelector('[data-urf-hero]');
    if (!root) return;
    var slides = root.querySelectorAll('[data-urf-slide]');
    var dots = root.querySelectorAll('[data-urf-dot]');
    if (slides.length < 2) return;
    var index = 0;
    function show(next) {
      index = next;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-on', i === index); });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-on', i === index); });
    }
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { show(i); });
    });
    if (!reduce) {
      window.setInterval(function () { show((index + 1) % slides.length); }, 6500);
    }
  }

  function bootShop() {
    var root = document.querySelector('[data-urf-shop]');
    if (!root) return;
    var title = root.querySelector('[data-urf-shop-title]');
    var viewAll = root.querySelector('[data-urf-shop-all]');
    var tabs = root.querySelectorAll('[data-urf-filter]');
    var panels = root.querySelectorAll('[data-urf-shop-panel]');
    function show(handle) {
      tabs.forEach(function (tab) {
        var on = tab.getAttribute('data-urf-filter') === handle;
        tab.classList.toggle('is-on', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        var on = panel.getAttribute('data-urf-shop-panel') === handle;
        panel.hidden = !on;
        panel.classList.toggle('is-on', on);
        if (on) {
          if (title) title.textContent = panel.getAttribute('data-title');
          if (viewAll) viewAll.href = panel.getAttribute('data-url');
        }
      });
    }
    var first = root.querySelector('[data-urf-filter].is-on') || tabs[0];
    if (first) show(first.getAttribute('data-urf-filter'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        show(tab.getAttribute('data-urf-filter'));
      });
    });
  }

  function bootReviews() {
    var root = document.querySelector('[data-urf-reviews]');
    if (!root) return;
    var track = root.querySelector('.urf-reviews__track');
    if (!track || track.children.length < 2) return;
    var prev = root.querySelector('[data-urf-review-prev]');
    var next = root.querySelector('[data-urf-review-next]');
    var paused = false;

    function step() {
      var card = track.children[0];
      return card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap || 0);
    }
    function atEnd() {
      return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }
    function sync() {
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = atEnd();
    }
    function go(direction) {
      track.scrollBy({ left: direction * step(), behavior: reduce ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function () { paused = false; });
    track.addEventListener('touchstart', function () { paused = true; }, { passive: true });
    sync();

    if (!reduce) {
      window.setInterval(function () {
        if (paused || document.hidden) return;
        if (atEnd()) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          go(1);
        }
      }, 6000);
    }
  }

  function start() {
    bootHeader();
    bootWishlist();
    bootHero();
    bootShop();
    bootReviews();
    bootLive();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
